export enum NotificationTypes {
  unknown = 0,
  reportDownloadReady = 1,
  trackMyJourneyDownloadReady = 51,
  respondentQuestionAnswered = 60
}
